import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import Frame                  from '../../../../State/Stores/Frame/Frame';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import UiEventType            from '../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';

import IconExitFullscreen    from './Assets/IconExitFullscreen';
import IconRequestFullscreen from './Assets/IconRequestFullscreen';

import * as styles           from './fullscreen.css';

interface IFullscreenProps extends IConnectProps<Frame> {
    areControlsIdle: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.FRAME)
class Fullscreen extends React.Component<IFullscreenProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public render(): JSX.Element {
        const {value, areControlsIdle} = this.props;
        const {isFrameFullscreened} = value;
        const Icon = isFrameFullscreened ? IconExitFullscreen : IconRequestFullscreen;

        const testIdBase = isFrameFullscreened ?
            TestIds.PLAYER_BUTTON_EXIT_FULLSCREEN :
            TestIds.PLAYER_BUTTON_ENTER_FULLSCREEN;

        const testId = composeTokenList([
            testIdBase,
            [!areControlsIdle, testIdBase + '_VISIBLE']
        ]);

        return (
            <button
                className={styles.fullscreen}
                onClick={this.handleClick}
                data-test-id={renderTestId(testId)}
            >
                <Icon/>
            </button>
        );
    }

    private handleClick(): void {
        this.props.uiEvents$.next({
            type: UiEventType.FULLSCREEN_TAP
        });
    }
}

export default Fullscreen;